export const FULL_SCREEN = {
  vw: 'calc(var(--vw, 1vw) * 100)',
  vh: 'calc(var(--vh, 1vh) * 100)',
};

export const LAYOUT_Z_INDEX = {
  NAVBAR: 120,
  SIDE_PANEL: 120,
};

export const LAYOUT_SIZE = {
  SIDE_BAR: 64,
  SIDE_PANEL: 360,
  NAV_HEIGHT: 56,
  MOBILE_MAP_TOP_BAR_HEIGHT: 60,
};

export const MEDIA_QUERIES = {
  mobile: '@media screen and (max-width: 767px)',
  tablet: '@media screen and (max-width: 1439px)',
  desktop: '@media screen and (min-width: 1440px)',

  tablet_only: '@media (min-width: 768px) and (max-width: 1439px)',
  exclude_mobile: '@media screen and (min-width: 768px)',
};
